import { System } from '../../data/types/system/system';

export const hasWormhole = (system: System): boolean =>
  system.wormHoleNameIndex > -1;

export const hasWormholeWith = (systemA: System, systemB: System): boolean =>
  systemA.wormHoleNameIndex === systemB.nameIndex;
